module.exports = __webpack_public_path__ + "img/safe-info-MSDS.c600ef3a.svg";